import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  CardMedia,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import SmokeAlarmIcon from '../../../assets/images/icons/ico_intro_smoke.svg'
import FireAlarmIcon from '../../../assets/images/icons/ico_intro_fire.svg'
import TemperatureIcon from '../../../assets/images/icons/ico_intro_temp.svg'
import HubIcon from '../../../assets/images/icons/ico_intro_hub.svg'

class TutorialStep2 extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    root: theme.introCardRoot,
    media: theme.introCardMedia,
    content: theme.introCardContent,
    mediaContainer: {
      height: '100%',
    },
  })

  render() {
    const { classes } = this.props

    return (
      <Card square elevation={3} classes={{ root: classes.root }}>
        <CardMedia className={classes.media}>
          <Grid container direction="row" justify="space-evenly" alignItems="center" className={classes.mediaContainer}>
            <Grid item><img src={SmokeAlarmIcon} alt="smoke alarm icon" /></Grid>
            <Grid item><img src={FireAlarmIcon} alt="fire alarm icon" /></Grid>
            <Grid item><img src={TemperatureIcon} alt="temperature icon" /></Grid>
            <Grid item><img src={HubIcon} alt="hub icon" /></Grid>
          </Grid>
        </CardMedia>
        <CardContent className={classes.content}>
          <Typography variant="h1">
            Subscribe to Community Alerts
          </Typography>
          <Typography variant="h2">
            Sensors, alerts, and reports to help you quickly identify and respond to safety and
            performance issues in your comunity.
          </Typography>
          <p>
            Events that will trigger an email alert:
          </p>
          <ul>
            <li>Smoke, carbon monoxide, or leak detection</li>
            <li>Fire sprinkler activity</li>
            <li>Low or high temperature</li>
            <li>Offline status of the BlokSense hub</li>
          </ul>
        </CardContent>
      </Card>
    )
  }
}

export default withStyles(TutorialStep2.styles)(TutorialStep2)
